import React, { useContext } from 'react'
import styled, { css, keyframes } from 'styled-components'

import { TranslationContext } from '@jarvis.oddle/core/components/Translation'
import Flex from '@jarvis.oddle/core/components/Flex'
import { H4, P } from '@jarvis.oddle/core/components/Typo'
import { colors } from '@jarvis.oddle/core/theme/default'

const BadgeContainer = styled(Flex).attrs(() => ({
  alignItems: 'center'
}))`
  position: relative;
`

const bounce = keyframes`
  0% {
    transform: translateY(0);
  }
  25% {
    transform: translateY(-50%);
  }
  50% {
    transform: translateY(0);
  }
  75% {
    transform: translateY(-25%);
  }
  100% {
    transform: translateY(0);
  }
`

const StyledBadge = styled(Flex).attrs(() => ({
  justifyContent: 'center',
  alignItems: 'center'
}))`
  width: 24px;
  height: 24px;
  border-radius: 13px;
  background-color: ${(props) =>
    props.background ? props.background : colors.headerBackground};
  margin: 0 10px 0 3px;
  ${props => props.withAnimation ? css`
    animation: ${bounce} 500ms ease-in-out;
  ` : ''}
`

const StyledText = styled(P).attrs((props) => ({
  textAlign: 'center',
  color: props.color ? props.color : colors.headerNav,
  fontSize: '14px'
}))``

const StyledStickyReservationText = styled(H4)`
  margin: 5px 5px 0 15px;
`

const BadgeComponent = ({
  Icon,
  value,
  iconSize,
  iconFillColor,
  badgeBackgroundColor,
  badgeTextColor,
  withAnimation = false,
  totalAmount
}: {
  Icon,
  value: number
  iconSize: string
  iconFillColor: string
  badgeBackgroundColor: string
  badgeTextColor: string
  withAnimation: boolean
  totalAmount: string
}): JSX.Element => {
  const { t } = useContext(TranslationContext)
  const shortedValue = value > 99 ? '99+' : value

  return (
    <BadgeContainer>
      <Icon iconSize={iconSize} fill={iconFillColor} />
      <StyledStickyReservationText
        color={iconFillColor}
      >
        {
          value > 0 ? totalAmount : t('Order')
        }
      </StyledStickyReservationText>
      {value > 0 && (
        <StyledBadge
          key={value}
          background={badgeBackgroundColor}
          withAnimation={withAnimation}
        >
          <StyledText
            bold
            color={badgeTextColor}
          >
            {shortedValue}
          </StyledText>
        </StyledBadge>
      )}
    </BadgeContainer>
  )
}

export default BadgeComponent
